var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yht-title"},[_c('p',{staticClass:"yht-title_name",domProps:{"textContent":_vm._s(_vm.titleName)}})])}
var staticRenderFns = []

export { render, staticRenderFns }